export default {
  ChangePasswordTitle: 'Change Password',
  ForgotPasswordTitle: 'Forgot Password',
  SetResetPasswordTitle: 'Set/Reset Password',
  LoginPageTitle: 'Login Page',
  RegisterPageTitle: 'Register Page',
  PersonalDetailsTitle: 'Personal Details Page',
  DashboardTitle: 'Dashboard Page',
  MyWalletTitle: 'Wallet',
  ReferAndEarnTitle: 'Refer And Earn',
  MyReferredListTitle: 'My Referred List',
  LeaderboardTitle: 'LeaderBoard Page',
  MyMatchesListTitle: 'My Matches List',
  FantasySportsPageTitle: 'Fantasy Sport Page',
  CricketHomeTitle: 'Cricket Home',
  ContestListTitle: 'Contest List',
  MyJoinedContestListTitle: 'My Joined Contest List',
  MyTeamListTitle: 'My Team List',
  CreateTeamPageTitle: 'Create Team Page',
  ChooseCVCPageTitle: 'Choose your Captain and Vice Captain',
  AllContestListTitle: 'All Contest List',
  TeamPreviewTitle: 'Team Preview Page',
  ContactUsPageTitle: 'Contact US Page',
  AddAddressTitle: 'Add Address',
  EditAddressTitle: 'Edit Address',
  ContestDetailsTitle: 'Contest Details',
  JoinContestTitle: 'Join Contest',
  PaytmPaymentPage: 'Paytm Payment Page',
  TeamPreview: 'Team Preview',
  LandingTitle: 'iGamio',
  ServerDown: 'Server Down',
  MegaContestWinner: 'Mega Contest Winner'
};
